import { render } from "./ProjectScreenImg.vue?vue&type=template&id=47ca4566&scoped=true"
import script from "./ProjectScreenImg.vue?vue&type=script&lang=js"
export * from "./ProjectScreenImg.vue?vue&type=script&lang=js"

import "./ProjectScreenImg.vue?vue&type=style&index=0&id=47ca4566&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ca4566"]])

export default __exports__